// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__2yEKN","progressBar":"styles_progressBar__qqwIl"};